<template>
  <b-section-loader :loading="$loading.isLoading('initialize')">
    <div>
      <div>
        <div class="mb-3 d-flex align-center justify-end">
          <v-btn
            v-show="showKey"
            variant="outlined"
            rounded="pill"
            style="border-width: 2px"
            @click="
              () => {
                showKey = false
              }
            ">
            <b>Видалити ключ</b>
          </v-btn>
        </div>
        <v-btn
          v-if="!showKey"
          style="border-width: 2px"
          variant="outlined"
          @click="showKey = true">
          Додати ключ <v-icon class="ml-2">mdi-plus</v-icon>
        </v-btn>
        <key-reader v-if="showKey" :keyType="keyType"></key-reader>
      </div>

      <v-divider class="mt-3 mb-3"></v-divider>

      <div>
        <div class="mb-3 d-flex align-center justify-space-between">
          <h3>Додайте за потреби печатку</h3>
          <v-btn
            v-show="showStamp"
            variant="outlined"
            rounded="pill"
            style="border-width: 2px"
            @click="
              () => {
                showStamp = false
              }
            ">
            Видалити печатку
          </v-btn>
        </div>
        <v-btn
          v-if="!showStamp"
          style="border-width: 2px"
          variant="outlined"
          @click="showStamp = true">
          Додати печатку <v-icon class="ml-2">mdi-plus</v-icon>
        </v-btn>
        <key-reader v-if="showStamp" :keyType="keyType" stamp></key-reader>
      </div>
      <div class="mt-4">
        <v-btn
          class="mb-2"
          block
          rounded="pill"
          :loading="$loading.isLoading('sendSign')"
          @click="sendSign">
          Затвердити і підписати
        </v-btn>
      </div>
    </div>
  </b-section-loader>
</template>

<script lang="ts">
import { inject, ref, PropType, computed } from 'vue'
import KeyReader from './KeyReader.vue'
import { initialize, keys, signFile } from '@/utils/signature'
import { KeyType, SignedDocument } from '../types'
import { BSectionLoader } from 'best-modules/components'
import { handleAsync } from 'best-modules/plugins'
import { AuthorizationKey, dialogKey, fileToSignKey } from '../injectionKeys'
import { uploadFiles } from '@/components/filesUploader/uploadFiles'

export default {
  name: 'SignLocal',
  emits: ['cancel'],
  components: { KeyReader, BSectionLoader },
  props: {
    keyType: {
      type: String as PropType<KeyType>,
      required: true,
    },
  },
  setup(props) {
    const dialog = inject(dialogKey)!
    const Authorization = inject(
      AuthorizationKey,
      computed(() => null)
    )
    const fileToSign = inject(fileToSignKey, ref([]))

    handleAsync('initialize', () => {
      return initialize(props.keyType)
    })

    const showStamp = ref<boolean>(false)
    const showKey = ref<boolean>(true)

    const sendSign = async () => {
      if (!keys.length) {
        return
      }

      const signatures: SignedDocument[] = []

      for (const document of fileToSign.value) {
        signatures.push(
          ...(await handleAsync('sendSign', () => {
            return Promise.all(
              keys.filter(Boolean).map(async k => {
                const { signBinary, signTimeStamp, signType } = await signFile(
                  k.privateKeyCtx,
                  document.file
                )
                const sign = new File(
                  [signBinary],
                  `${document.fileName}.p7s`,
                  {
                    type: 'application/pkcs7-signature',
                  }
                )
                const { paths } = await uploadFiles({
                  ...document.uploadFilesParams,
                  files: sign,
                  Authorization: Authorization.value || undefined,
                  prefixFolder:
                    document.uploadFilesParams?.prefixFolder ||
                    String(document.document.id),
                })

                return {
                  document: document.document,
                  documentSigned: paths[0],
                  signingDate: signTimeStamp,
                  fullCertificate: {
                    certificateInfo: k.ownerInfo,
                    containerType: 'detached',
                    signType,
                  },
                  meta: document.meta,
                }
              })
            )
          }))
        )
      }

      return dialog.submit(signatures)
    }

    return { showKey, showStamp, sendSign, keys }
  },
}
</script>

<style scoped lang="scss"></style>
